/*
 * STEPMASTERS a11y A-33: Vorlesen (Theme 2.37).
 * Liest Texte mit der Sprachausgabe des Browsers vor (Web Speech API, window.speechSynthesis):
 * - Bereiche, die das Theme mit data-sm-vorlesen markiert (Name in data-sm-vorlesen-titel), dazu die
 *   Shopify-Richtlinien (/policies/*). Vor jeden Bereich kommt eine kleine Werkzeugleiste: "Vorlesen",
 *   waehrend des Lesens "Pause"/"Weiter", "Stopp" und "Tempo".
 * - markierten Text im Hauptinhalt ueber einen schwebenden Knopf "Markierung vorlesen".
 * Datenschutz: nur Stimmen mit localService === true. Netzwerkstimmen (z. B. "Google ..." in Chrome oder
 * "Microsoft ... Online" in Edge) schicken den Text an fremde Server und werden nie verwendet.
 * Keine Cookies, kein localStorage; nur das Tempo liegt in sessionStorage.
 * Ohne Web Speech API oder ohne passende lokale Stimme erscheinen keine Bedienelemente.
 * Texte: sm.vorlesen.* aus den Sprachdateien ueber #sm-vorlesen-config (snippets/sm-vorlesen.liquid).
 * Statusmeldungen nur ueber #sm-vorlesen-status. Stile: assets/stepmasters.css, Abschnitt A-33.
 */
(function () {
  'use strict';

  var synth = window.speechSynthesis;
  var config = document.getElementById('sm-vorlesen-config');
  var statusRegion = document.getElementById('sm-vorlesen-status');
  var main = document.getElementById('MainContent');

  if (window.smVorlesenGeladen) return;
  // Theme 2.39 (Shoptest #50): Ohne Sprachausgabe den im <head> freigehaltenen Platz gleich wieder freigeben
  if (!synth || typeof window.SpeechSynthesisUtterance !== 'function' || !config || !statusRegion || !main) {
    document.documentElement.classList.remove('sm-vorlesen-platz');
    return;
  }
  window.smVorlesenGeladen = true;

  var msg = config.dataset;
  var seitenSprache = String(document.documentElement.lang || 'de').toLowerCase();
  var TEMPI = [0.8, 1, 1.25];
  var TEMPO_SCHLUESSEL = 'sm-vorlesen-tempo';
  // Chrome bricht lange Aeusserungen teils nach etwa 15 s ab, deshalb kurze Stuecke
  var MAX_STUECK = 200;

  var stimme = null; // gewaehlte lokale Stimme
  var sitzung = null; // laufendes Vorlesen: { steuerung, teile, index, mitscrollen, versuche }
  var generation = 0; // Ereignisse aelterer Aeusserungen ignorieren (nach Pause, Stopp, Neustart)
  var aeusserung = null; // Referenz halten, sonst raeumt der Garbage Collector sie ab und onend kommt nie
  var wachhund = 0;
  var markiert = null; // gerade hervorgehobener Block
  var abgleichGeplant = false;
  var tempo = tempoLesen();

  /* ---------- Stimme waehlen (Datenschutz: nur lokale Stimmen) ---------- */

  // Bevorzugte Region je Shop-Sprache, wenn es mehrere lokale Stimmen gibt
  var REGIONEN = { de: 'de-de', en: 'en-gb', fr: 'fr-fr', es: 'es-es', it: 'it-it', pl: 'pl-pl' };
  // Effektstimmen von Apple (macOS, iOS) sind fuer Fliesstext ungeeignet
  var EFFEKTSTIMMEN = /^(albert|bad news|bahh|bells|boing|bubbles|cellos|deranged|good news|hysterical|jester|organ|pipe organ|superstar|trinoids|whisper|wobble|zarvox)\b/i;
  // Eloquence-Stimmen (macOS, iOS) nur, wenn es keine bessere gibt
  var SCHWACHE_STIMMEN = /^(eddy|flo|grandma|grandpa|reed|rocko|sandy|shelley)\b/i;

  function sprachcode(lang) {
    return String(lang || '').replace(/_/g, '-').toLowerCase();
  }

  function stimmeWaehlen() {
    var stimmen = synth.getVoices() || [];
    var basis = seitenSprache.split('-')[0];
    var exakt = seitenSprache.indexOf('-') > 0 ? seitenSprache : '';
    var region = REGIONEN[basis] || '';
    var beste = null;
    var bestePunkte = -1;

    for (var i = 0; i < stimmen.length; i++) {
      var s = stimmen[i];
      if (!s || s.localService !== true) continue;
      var code = sprachcode(s.lang);
      if (code.split('-')[0] !== basis || EFFEKTSTIMMEN.test(s.name)) continue;

      var punkte = 0;
      if (exakt && code === exakt) punkte += 8;
      else if (region && code === region) punkte += 4;
      if (s['default']) punkte += 2;
      if (!SCHWACHE_STIMMEN.test(s.name)) punkte += 1;
      if (punkte > bestePunkte) {
        beste = s;
        bestePunkte = punkte;
      }
    }
    return beste;
  }

  // Ist die gewaehlte Stimme noch da und lokal? Sonst wuerde der Browser ueber u.lang womoeglich eine
  // Netzwerkstimme nehmen.
  function stimmeVorhanden() {
    if (!stimme) return false;
    var stimmen = synth.getVoices() || [];
    for (var i = 0; i < stimmen.length; i++) {
      var s = stimmen[i];
      if (s && s.localService === true && s.voiceURI === stimme.voiceURI && s.name === stimme.name) return true;
    }
    return false;
  }

  /* Merker fuer den freigehaltenen Platz (assets/stepmasters.css A-33, Skript im <head> von layout/theme.liquid):
   * '1' = in dieser Sitzung gibt es fuer diese Sprache eine lokale Stimme, '0' = keine (dann haelt der <head> keinen
   * Platz mehr frei; Theme 2.39, Shoptest #50: ohne Merker wird Platz freigehalten). Nur sessionStorage, kein
   * Personenbezug. */
  var PLATZ_SCHLUESSEL = 'sm-vorlesen-stimme-' + seitenSprache.split('-')[0];

  function platzMerken(ja) {
    try {
      window.sessionStorage.setItem(PLATZ_SCHLUESSEL, ja ? '1' : '0');
    } catch (e) {
      /* sessionStorage gesperrt: dann wird kein Platz freigehalten */
    }
  }

  function platzFreigeben() {
    document.documentElement.classList.remove('sm-vorlesen-platz');
  }

  // Alle Bedienelemente entfernen (keine passende lokale Stimme mehr)
  function bedienungEntfernen() {
    if (sitzung) beenden(true);
    var leisten = main.querySelectorAll('[data-sm-vorlesen-leiste="bereich"]');
    for (var i = 0; i < leisten.length; i++) leisten[i].parentNode.removeChild(leisten[i]);
    auswahlSchliessen(false);
  }

  function stimmenLaden() {
    if (sitzung) return; // waehrend des Lesens nicht umschalten (sprechen() prueft die Stimme vor jedem Satz)
    var neu = stimmeWaehlen();
    var liste = synth.getVoices() || [];
    stimme = neu;
    if (stimme) {
      platzMerken(true);
      abgleichPlanen();
    } else {
      bedienungEntfernen();
      // Liegt schon eine Stimmenliste vor, gibt es sicher keine passende lokale Stimme
      if (liste.length) {
        platzMerken(false);
        platzFreigeben();
      }
    }
  }

  // Stimmen kommen in Chrome, Edge und Firefox asynchron: voiceschanged plus kurzes Nachfragen (max. 3 s)
  if (typeof synth.addEventListener === 'function') synth.addEventListener('voiceschanged', stimmenLaden);
  stimmenLaden();
  if (!stimme) {
    var versuche = 0;
    var abfrage = setInterval(function () {
      versuche++;
      if (!stimme) stimmenLaden();
      if (stimme || versuche >= 12) {
        clearInterval(abfrage);
        if (!stimme) {
          platzMerken(false);
          platzFreigeben();
        }
      }
    }, 250);
  }

  /* ---------- Hilfen ---------- */

  function tempoLesen() {
    try {
      var wert = parseFloat(window.sessionStorage.getItem(TEMPO_SCHLUESSEL));
      if (TEMPI.indexOf(wert) !== -1) return wert;
    } catch (e) {
      /* sessionStorage gesperrt: Standardtempo */
    }
    return 1;
  }

  function tempoSpeichern(wert) {
    try {
      window.sessionStorage.setItem(TEMPO_SCHLUESSEL, String(wert));
    } catch (e) {
      /* nicht speicherbar: gilt nur fuer diese Seite */
    }
  }

  // Platzhalter aus snippets/sm-vorlesen.liquid (t-Filter mit title: '%TITEL%')
  function vorlage(text, titel) {
    // Funktion statt String: "$&" oder "$'" in einem Titel sonst als Ersetzungsmuster gelesen
    return String(text || '').replace('%TITEL%', function () {
      return titel;
    });
  }

  function elementVon(knoten) {
    if (!knoten) return null;
    return knoten.nodeType === 1 ? knoten : knoten.parentElement;
  }

  var ansageTimer = 0;

  // Einzige Live-Region: kurz leeren und neu setzen, damit auch gleiche Meldungen angesagt werden
  function ansagen(text) {
    clearTimeout(ansageTimer);
    statusRegion.textContent = '';
    if (!text) return;
    ansageTimer = setTimeout(function () {
      statusRegion.textContent = text;
      ansageTimer = setTimeout(function () {
        statusRegion.textContent = '';
      }, 6000);
    }, 120);
  }

  /* ---------- Werkzeugleiste ---------- */

  var SVG_ANFANG =
    '<svg class="sm-vorlesen__icon" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" ' +
    'stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">';
  var ICONS = {
    lautsprecher: '<path d="M4 9.5h3.5L12 5.5v13l-4.5-4H4z"/><path d="M15.5 9a4 4 0 0 1 0 6"/><path d="M18 6.5a7.5 7.5 0 0 1 0 11"/>',
    pause: '<path d="M9 6v12"/><path d="M15 6v12"/>',
    weiter: '<path d="M8 5.5v13l10.5-6.5z"/>',
    stopp: '<rect x="6.5" y="6.5" width="11" height="11" rx="1.5"/>'
  };

  function knopfInhalt(knopf, icon, text) {
    knopf.innerHTML = SVG_ANFANG + ICONS[icon] + '</svg>';
    var beschriftung = document.createElement('span');
    beschriftung.textContent = text;
    knopf.appendChild(beschriftung);
  }

  function knopfBauen(aktion) {
    var knopf = document.createElement('button');
    knopf.type = 'button';
    knopf.className = 'sm-vorlesen__btn sm-vorlesen__btn--' + aktion;
    knopf.setAttribute('data-sm-vorlesen-aktion', aktion);
    return knopf;
  }

  // art: 'bereich' (Leiste vor einem Bereich) oder 'auswahl' (schwebender Knopf fuer markierten Text)
  function steuerungBauen(art, titel) {
    var leiste = document.createElement('div');
    leiste.className = 'sm-vorlesen' + (art === 'auswahl' ? ' sm-vorlesen--auswahl' : '');
    leiste.setAttribute('data-sm-vorlesen-leiste', art);

    var start = knopfBauen('lesen');
    var stopp = knopfBauen('stopp');
    knopfInhalt(stopp, 'stopp', msg.msgStop);

    var tempoFeld = document.createElement('label');
    tempoFeld.className = 'sm-vorlesen__tempo';
    var tempoText = document.createElement('span');
    tempoText.textContent = msg.msgSpeed;
    var auswahl = document.createElement('select');
    auswahl.className = 'sm-vorlesen__select';
    auswahl.setAttribute('data-sm-vorlesen-aktion', 'tempo');
    var namen = [msg.msgSpeedSlow, msg.msgSpeedNormal, msg.msgSpeedFast];
    for (var i = 0; i < TEMPI.length; i++) {
      var option = document.createElement('option');
      option.value = String(TEMPI[i]);
      option.textContent = namen[i];
      auswahl.appendChild(option);
    }
    tempoFeld.appendChild(tempoText);
    tempoFeld.appendChild(auswahl);

    leiste.appendChild(start);
    leiste.appendChild(stopp);
    leiste.appendChild(tempoFeld);

    var steuerung = {
      art: art,
      titel: titel,
      leiste: leiste,
      start: start,
      stopp: stopp,
      tempoFeld: tempoFeld,
      auswahl: auswahl,
      bereich: null,
      zustand: ''
    };
    leiste.smVorlesen = steuerung;
    zeigen(steuerung, 'bereit');
    return steuerung;
  }

  // Zustand anzeigen: 'bereit', 'spielt' oder 'pausiert'
  function zeigen(s, zustand) {
    s.zustand = zustand;
    // Umbruch der Leiste kann Scroll-Anker verschieben: das ist kein Scrollen durch die Person
    eigenesScrollen(400);
    var aktiv = zustand !== 'bereit';

    if (zustand === 'spielt') knopfInhalt(s.start, 'pause', msg.msgPause);
    else if (zustand === 'pausiert') knopfInhalt(s.start, 'weiter', msg.msgResume);
    else knopfInhalt(s.start, 'lautsprecher', s.art === 'auswahl' ? msg.msgReadSelection : msg.msgRead);

    // Name im Ruhezustand mit Bereich ("Produktbeschreibung vorlesen"), sonst der sichtbare Text (Pause/Weiter)
    if (!aktiv && s.art === 'bereich') s.start.setAttribute('aria-label', vorlage(msg.msgReadArea, s.titel));
    else s.start.removeAttribute('aria-label');

    // Fokus nicht verlieren, wenn Stopp oder Tempo verschwinden
    var fokus = document.activeElement;
    if (!aktiv && fokus && fokus !== s.start && s.leiste.contains(fokus)) s.start.focus({ preventScroll: true });

    s.stopp.hidden = !aktiv;
    s.tempoFeld.hidden = !aktiv;
    s.auswahl.value = String(tempo);
    s.leiste.classList.toggle('is-aktiv', aktiv);
    if (s.art === 'auswahl') positionPlanen();
  }

  /* ---------- Bereiche finden und Leisten einsetzen (idempotent, auch nach morph und im Theme-Editor) ---------- */

  // Shopify-Richtlinien haben kein Template im Theme: Bereich und Namen hier setzen
  // Bereich ist .rte im Textkoerper: Die Leiste steht dann innen am Anfang des Textkoerpers. So verschiebt
  // sich beim Einsetzen weder der Textkoerper noch der Text gegenueber dem freigehaltenen Platz (A-33 CSS).
  function richtlinieMarkieren() {
    var koerper = main.querySelector('.shopify-policy__body');
    if (!koerper) return;
    var ziel = koerper.querySelector(':scope > .rte') || koerper;
    if (ziel.hasAttribute('data-sm-vorlesen')) return;
    var titel = main.querySelector('.shopify-policy__title');
    var name = titel ? titel.textContent.replace(/\s+/g, ' ').trim() : '';
    ziel.setAttribute('data-sm-vorlesen', '');
    ziel.setAttribute('data-sm-vorlesen-titel', name || msg.msgAreaLegal);
  }

  // Nachbarn ohne den schwebenden Knopf, der zeitweise im Inhalt steht
  function istSchwebend(el) {
    return !!el && el.getAttribute('data-sm-vorlesen-leiste') === 'auswahl';
  }

  function naechstesElement(el) {
    var n = el.nextElementSibling;
    while (istSchwebend(n)) n = n.nextElementSibling;
    return n;
  }

  function vorigesElement(el) {
    var n = el.previousElementSibling;
    while (istSchwebend(n)) n = n.previousElementSibling;
    return n;
  }

  function leisteGueltig(s) {
    return (
      !!s.bereich &&
      s.leiste.isConnected &&
      s.leiste.getAttribute('data-sm-vorlesen-leiste') === 'bereich' &&
      naechstesElement(s.leiste) === s.bereich &&
      s.bereich.hasAttribute('data-sm-vorlesen')
    );
  }

  // setTimeout statt requestAnimationFrame: laeuft auch in Hintergrund-Tabs und fasst Aenderungen zusammen
  function abgleichPlanen() {
    if (abgleichGeplant) return;
    abgleichGeplant = true;
    setTimeout(abgleichen, 50);
  }

  function abgleichen() {
    abgleichGeplant = false;
    if (!stimme) return;
    richtlinieMarkieren();

    // Lag der Fokus in einer Leiste, die ersetzt wird, kommt er danach auf "Vorlesen" der neuen Leiste
    var fokusVorher = document.activeElement;
    var fokusBereich = null;
    var fokusTitel = null;

    // Leisten entfernen, deren Bereich weg ist oder die nicht mehr direkt davor stehen
    var leisten = main.querySelectorAll('[data-sm-vorlesen-leiste="bereich"]');
    var i;
    for (i = 0; i < leisten.length; i++) {
      var s = leisten[i].smVorlesen;
      if (s && leisteGueltig(s)) continue;
      if (s && fokusVorher && leisten[i].contains(fokusVorher)) {
        fokusBereich = s.bereich;
        fokusTitel = s.titel;
      }
      // Ansage, damit auch Screenreader-Nutzer merken, warum die Stimme verstummt
      if (s && sitzung && sitzung.steuerung === s) beenden(true);
      leisten[i].parentNode.removeChild(leisten[i]);
    }

    // Laufendes Vorlesen, dessen Bedienelemente das Theme ersetzt hat (z. B. nach Neurendern), beenden
    if (sitzung) {
      var aktiv = sitzung.steuerung;
      if (aktiv.art === 'bereich' ? !leisteGueltig(aktiv) : !aktiv.leiste.isConnected) beenden(true);
    }

    var neuerFokus = null;
    var bereiche = main.querySelectorAll('[data-sm-vorlesen]');
    for (i = 0; i < bereiche.length; i++) {
      var bereich = bereiche[i];
      var davor = vorigesElement(bereich);
      if (davor && davor.smVorlesen && davor.smVorlesen.bereich === bereich && leisteGueltig(davor.smVorlesen)) continue;
      // verschachtelte Bereiche: nur der aeussere bekommt eine Leiste
      if (bereich.parentElement && bereich.parentElement.closest('[data-sm-vorlesen]')) continue;
      if (!bereich.textContent.replace(/\s+/g, '')) continue;

      var titel = (bereich.getAttribute('data-sm-vorlesen-titel') || '').trim() || msg.msgAreaSection;
      var steuerung = steuerungBauen('bereich', titel);
      steuerung.bereich = bereich;
      bereich.parentNode.insertBefore(steuerung.leiste, bereich);
      if (fokusTitel !== null && !neuerFokus && (bereich === fokusBereich || titel === fokusTitel)) neuerFokus = steuerung.start;
    }
    if (neuerFokus) neuerFokus.focus({ preventScroll: true });

    // Leisten stehen: freigehaltenen Platz im selben Schritt freigeben (kein Sprung)
    platzFreigeben();
  }

  // Abschnitte werden per morph oder im Theme-Editor neu gerendert: neu abgleichen, ohne doppelte Leisten
  new MutationObserver(function (eintraege) {
    for (var i = 0; i < eintraege.length; i++) {
      if (eintraege[i].type === 'childList') {
        abgleichPlanen();
        return;
      }
    }
  }).observe(main, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', abgleichPlanen);
  document.addEventListener('shopify:section:unload', abgleichPlanen);

  /* ---------- Text sammeln ---------- */

  var BLOCK_TAGS = /^(P|LI|H[1-6]|DT|DD|TD|TH|BLOCKQUOTE|FIGCAPTION|CAPTION|SUMMARY|PRE|ADDRESS)$/;
  var CONTAINER_INHALT = 'p, li, h1, h2, h3, h4, h5, h6, dt, dd, td, th, blockquote, figcaption, div, ul, ol, dl, table, details, section, article';
  var AUSLASSEN_TAGS =/^(SCRIPT|STYLE|NOSCRIPT|TEMPLATE|SVG|IMG|PICTURE|VIDEO|AUDIO|IFRAME|CANVAS|OBJECT|EMBED|MATH|BUTTON|INPUT|SELECT|TEXTAREA|FORM|DIALOG)$/;

  function auslassen(el, stil) {
    if (AUSLASSEN_TAGS.test(el.nodeName.toUpperCase())) return true;
    if (el.hasAttribute('hidden') || el.getAttribute('aria-hidden') === 'true') return true;
    if (el.hasAttribute('data-sm-vorlesen-aus') || el.hasAttribute('data-sm-vorlesen-leiste')) return true;
    // Versteckte Hilfstexte (z. B. "oeffnet in neuem Fenster") gehoeren nicht in den Lesefluss
    if (el.classList.contains('visually-hidden')) return true;
    return stil.display === 'none' || stil.visibility === 'hidden';
  }

  // Liefert sichtbare Textbloecke in Lesereihenfolge: [{ el, text }]. Inhalte zugeklappter <details>
  // zaehlen mit (die FAQ-Antworten sollen vorgelesen werden).
  function bloeckeSammeln(wurzel) {
    var bloecke = [];

    function neuerBlock(el) {
      var block = { el: el, text: '' };
      bloecke.push(block);
      return block;
    }

    function besuchen(el, block) {
      var lose = null; // Block fuer Text, der direkt in einem Container steht
      for (var k = el.firstChild; k; k = k.nextSibling) {
        if (k.nodeType === 3) {
          if (block) block.text += k.nodeValue;
          else if (/\S/.test(k.nodeValue)) (lose || (lose = neuerBlock(el))).text += k.nodeValue;
          else if (lose) lose.text += ' ';
          continue;
        }
        if (k.nodeType !== 1) continue;

        var stil = window.getComputedStyle(k);
        if (auslassen(k, stil)) continue;
        var name = k.nodeName.toUpperCase();
        var inline = stil.display.indexOf('inline') === 0;
        // Inline-Element mit Bloecken darin (z. B. <rte-formatter> ohne display) wie einen Container behandeln,
        // sonst landet loser Text darin vor allen Absaetzen
        if (inline && !block && k.firstElementChild && k.querySelector(CONTAINER_INHALT)) inline = false;

        if (name === 'BR') {
          if (block || lose) (block || lose).text += ' ';
        } else if (BLOCK_TAGS.test(name)) {
          lose = null;
          besuchen(k, neuerBlock(k));
        } else if (block) {
          if (!inline) block.text += ' ';
          besuchen(k, block);
          if (!inline) block.text += ' ';
        } else if (inline) {
          besuchen(k, lose || (lose = neuerBlock(el)));
        } else {
          lose = null;
          besuchen(k, null);
        }
      }
    }

    besuchen(wurzel, null);

    var ergebnis = [];
    for (var i = 0; i < bloecke.length; i++) {
      var text = bloecke[i].text.replace(/\s+/g, ' ').trim();
      if (text) ergebnis.push({ el: bloecke[i].el, text: text });
    }
    return ergebnis;
  }

  /* ---------- In Saetze und kurze Stuecke teilen ---------- */

  var segmentierer = null;
  try {
    if (window.Intl && typeof Intl.Segmenter === 'function') {
      segmentierer = new Intl.Segmenter(seitenSprache, { granularity: 'sentence' });
    }
  } catch (e) {
    segmentierer = null;
  }

  // Endet ein Stueck auf eine Abkuerzung oder Ordinalzahl ("z. B.", "Abs.", "Nr.", "3. Oktober", "inkl."),
  // ist dort kein Satzende: mit dem naechsten Stueck verbinden. Lieber zu viel verbinden, stueckeln()
  // begrenzt ohnehin auf MAX_STUECK Zeichen.
  var ABKUERZUNG = new RegExp(
    '(?:^|[\\s(/„"«])(?:\\d{1,4}|[A-Za-zÄÖÜäöüß]|z\\.\\s?B|d\\.\\s?h|u\\.\\s?a|o\\.\\s?ä|i\\.\\s?d\\.\\s?R|s\\.\\s?o|s\\.\\s?u|' +
      'Abs|Nr|Art|Ziff|lit|Bd|Kap|ca|bzw|ggf|inkl|zzgl|exkl|evtl|usw|vgl|bspw|sog|Str|Tel|Mio|Mrd|etc|' +
      'e\\.g|i\\.e|approx|incl|Dr|Prof|Mr|Mrs|Ms|St|No|n°|pp|vs|Jan|Feb|Mär|Apr|Jun|Jul|Aug|Sep|Sept|Okt|Oct|Nov|Dez|Dec|' +
      'max|min|Hrsg|Anm|ff|Mo|Di|Mi|Do|Fr|Sa|So|MwSt|USt|Std|Tsd|bzgl|gem|lt|einschl|Mme|Mlle|cf|env|al|ul)\\.$',
    'i'
  );

  function saetze(text) {
    var roh;
    if (segmentierer) {
      roh = Array.from(segmentierer.segment(text), function (teil) {
        return teil.segment;
      });
    } else {
      // Ersatz ohne Intl.Segmenter: nur trennen, wenn nach dem Satzzeichen ein Leerraum folgt ("1.000" und
      // "stepmasters.de" bleiben ganz)
      roh = text.replace(/([.!?…]+["'“”„»«)\]]*)\s+/g, '$1\u0000').split('\u0000');
    }
    var ergebnis = [];
    for (var i = 0; i < roh.length; i++) {
      var teil = roh[i].trim();
      if (!teil) continue;
      var letzter = ergebnis.length - 1;
      if (letzter >= 0 && (ABKUERZUNG.test(ergebnis[letzter]) || ergebnis[letzter].length < 12)) {
        ergebnis[letzter] += ' ' + teil;
      } else {
        ergebnis.push(teil);
      }
    }
    return ergebnis.length ? ergebnis : [text];
  }

  function stueckeln(satz, ziel) {
    satz = satz.trim();
    while (satz.length > MAX_STUECK) {
      var vorne = satz.slice(0, MAX_STUECK);
      var schnitt = -1;
      // bevorzugt nach Satzzeichen im Satz trennen, sonst am letzten Leerzeichen
      var muster = /[,;:–—)]\s/g;
      var treffer;
      while ((treffer = muster.exec(vorne))) {
        if (treffer.index >= 60) schnitt = treffer.index + 1;
      }
      if (schnitt < 0) schnitt = vorne.lastIndexOf(' ');
      if (schnitt < 40) schnitt = MAX_STUECK;
      ziel.push(satz.slice(0, schnitt).trim());
      satz = satz.slice(schnitt).trim();
    }
    if (satz) ziel.push(satz);
  }

  function teileBilden(bloecke) {
    var teile = [];
    for (var i = 0; i < bloecke.length; i++) {
      var liste = saetze(bloecke[i].text);
      for (var j = 0; j < liste.length; j++) {
        var stuecke = [];
        stueckeln(liste[j], stuecke);
        for (var k = 0; k < stuecke.length; k++) teile.push({ text: stuecke[k], el: bloecke[i].el });
      }
    }
    return teile;
  }

  /* ---------- Hervorheben und Mitscrollen ---------- */

  var reduzierteBewegung = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  // Zugeklappte <details>: die Antwort ist unsichtbar, deshalb das ganze <details> (die Frage) markieren
  function sichtbaresZiel(el) {
    var ziel = el;
    for (var k = el; k && k !== main; k = k.parentElement) {
      var eltern = k.parentElement;
      if (eltern && eltern.nodeName === 'DETAILS' && !eltern.open) ziel = eltern;
    }
    return ziel;
  }

  function hervorheben(el) {
    var ziel = el ? sichtbaresZiel(el) : null;
    if (ziel === markiert) return;
    if (markiert) markiert.removeAttribute('data-sm-vorlesen-aktiv');
    markiert = ziel;
    if (!ziel) return;
    ziel.setAttribute('data-sm-vorlesen-aktiv', '');
    if (sitzung && sitzung.mitscrollen) insBild(ziel);
  }

  function insBild(el) {
    var r = el.getBoundingClientRect();
    var hoehe = window.innerHeight || document.documentElement.clientHeight;
    var oben = 90; // Platz fuer den klebenden Header
    var hoch = r.height > hoehe - oben - 16;
    if (hoch ? r.top >= oben && r.top <= hoehe / 2 : r.top >= oben && r.bottom <= hoehe - 16) return;
    var sanft = !(reduzierteBewegung && reduzierteBewegung.matches);
    eigenesScrollen(sanft ? 1500 : 300);
    el.scrollIntoView({
      block: hoch ? 'start' : 'center',
      inline: 'nearest',
      behavior: sanft ? 'smooth' : 'auto'
    });
  }

  // Scroll-Ereignisse bis zu diesem Zeitpunkt stammen vom Vorlesen selbst (Mitscrollen, Leiste bricht um)
  var eigenerScrollBis = 0;

  function eigenesScrollen(ms) {
    eigenerScrollBis = Math.max(eigenerScrollBis, Date.now() + ms);
  }

  // Scrollt jemand selbst, scrollt das Vorlesen bis zum naechsten Start nicht mehr mit (WCAG 2.2.2)
  function nutzerScrollt(event) {
    if (!sitzung) return;
    if (event.type === 'keydown') {
      if (!/^(PageUp|PageDown|Home|End|ArrowUp|ArrowDown| )$/.test(event.key)) return;
      var ziel = event.target;
      if (ziel && (ziel.isContentEditable || /^(INPUT|TEXTAREA|SELECT|BUTTON)$/.test(ziel.nodeName))) return;
    }
    sitzung.mitscrollen = false;
  }

  window.addEventListener('wheel', nutzerScrollt, { passive: true });
  window.addEventListener('touchmove', nutzerScrollt, { passive: true });
  // Scrollleiste ziehen, mittlere Maustaste, Ankerlinks: jedes Scrollen, das nicht vom Vorlesen kommt.
  // Am Desktop scrollt .page-wrapper statt des Fensters: scroll blubbert nicht, deshalb Capture.
  document.addEventListener(
    'scroll',
    function (event) {
      if (!sitzung) return;
      var jetzt = Date.now();
      // Sanftes Mitscrollen kann laenger dauern: solange es laeuft, das eigene Zeitfenster kurz verlaengern
      if (jetzt <= eigenerScrollBis) eigenerScrollBis = Math.max(eigenerScrollBis, jetzt + 120);
      else nutzerScrollt(event);
    },
    { capture: true, passive: true }
  );

  /* ---------- Sprechen ---------- */

  function abbrechen() {
    if (synth.speaking || synth.pending) synth.cancel();
  }

  function starten(s, teile) {
    if (sitzung) beenden(false); // nur ein Bereich liest gleichzeitig
    if (!teile.length || !stimme) return;
    sitzung = { steuerung: s, teile: teile, index: 0, mitscrollen: true, versuche: 0 };
    zeigen(s, 'spielt');
    ansagen(msg.msgStarted);
    sprechen();
  }

  // Muss beim Start synchron im Klick laufen (iOS spricht sonst nicht)
  function sprechen() {
    var lauf = ++generation;
    clearTimeout(wachhund);
    var teil = sitzung && sitzung.teile[sitzung.index];
    if (!teil) {
      beenden(true);
      return;
    }
    // Datenschutz: nur sprechen, wenn die gewaehlte lokale Stimme noch da ist
    if (!stimmeVorhanden()) {
      fehlschlag();
      stimmenLaden();
      return;
    }
    hervorheben(teil.el);

    var u = new SpeechSynthesisUtterance(teil.text);
    // Stimme und Sprache immer setzen: nur mit lang waehlt Chrome womoeglich eine Netzwerkstimme
    u.voice = stimme;
    u.lang = String(stimme.lang || seitenSprache).replace(/_/g, '-');
    u.rate = tempo;
    u.pitch = 1;
    u.volume = 1;

    var gestartet = false;
    u.onstart = function () {
      if (lauf === generation) gestartet = true;
    };
    u.onend = function () {
      if (lauf !== generation || !sitzung) return;
      clearTimeout(wachhund);
      sitzung.index++;
      sitzung.versuche = 0;
      sprechen();
    };
    u.onerror = function (event) {
      if (lauf !== generation || !sitzung) return;
      clearTimeout(wachhund);
      // Von aussen unterbrochen (andere Ausgabe, System): wie Pause behandeln, Weiter liest den Satz neu
      if (event.error === 'canceled' || event.error === 'interrupted') pausieren();
      else fehlschlag();
    };

    aeusserung = u;
    if (synth.paused) synth.resume();
    synth.speak(u);

    // Wachhund: Chrome verwirft gelegentlich ein speak() direkt nach cancel(). Einmal neu versuchen.
    wachhund = setTimeout(function () {
      if (lauf !== generation || !sitzung || gestartet || synth.speaking) return;
      if (sitzung.versuche >= 1) {
        fehlschlag();
        return;
      }
      sitzung.versuche++;
      generation++;
      abbrechen();
      var erwartet = generation;
      setTimeout(function () {
        if (erwartet === generation && sitzung && sitzung.steuerung.zustand === 'spielt') sprechen();
      }, 80);
    }, 2500);
  }

  // Pause = abbrechen und Position merken (pause()/resume() sind in Chrome und Android unzuverlaessig)
  function pausieren() {
    if (!sitzung) return;
    generation++;
    clearTimeout(wachhund);
    abbrechen();
    zeigen(sitzung.steuerung, 'pausiert');
    ansagen(msg.msgPaused);
  }

  // Weiter = ab dem aktuellen Satz neu sprechen
  function fortsetzen() {
    if (!sitzung) return;
    sitzung.mitscrollen = true;
    sitzung.versuche = 0;
    zeigen(sitzung.steuerung, 'spielt');
    sprechen();
  }

  function beenden(ansage) {
    generation++;
    clearTimeout(wachhund);
    abbrechen();
    aeusserung = null;
    hervorheben(null);
    var s = sitzung && sitzung.steuerung;
    sitzung = null;
    if (s) {
      zeigen(s, 'bereit');
      if (s.art === 'auswahl') setTimeout(auswahlPruefen, 0);
    }
    if (ansage) ansagen(msg.msgEnded);
  }

  function fehlschlag() {
    beenden(false);
    ansagen(msg.msgError);
  }

  /* ---------- Bedienung ---------- */

  document.addEventListener('click', function (event) {
    var ziel = event.target instanceof Element ? event.target.closest('button[data-sm-vorlesen-aktion]') : null;
    if (!ziel) return;
    var leiste = ziel.closest('[data-sm-vorlesen-leiste]');
    var s = leiste && leiste.smVorlesen;
    if (!s) return;

    var aktiv = sitzung && sitzung.steuerung === s;
    if (ziel.getAttribute('data-sm-vorlesen-aktion') === 'stopp') {
      if (aktiv) beenden(true);
      return;
    }
    if (aktiv) {
      if (s.zustand === 'spielt') pausieren();
      else fortsetzen();
      return;
    }
    if (s.art === 'auswahl') {
      var teile = [];
      var liste = saetze(s.text || '');
      for (var i = 0; i < liste.length; i++) stueckeln(liste[i], teile);
      starten(s, teile.map(function (text) {
        return { text: text, el: null };
      }));
    } else if (s.bereich) {
      starten(s, teileBilden(bloeckeSammeln(s.bereich)));
    }
  });

  document.addEventListener('change', function (event) {
    var feld = event.target;
    if (!(feld instanceof HTMLSelectElement) || feld.getAttribute('data-sm-vorlesen-aktion') !== 'tempo') return;
    var wert = parseFloat(feld.value);
    if (TEMPI.indexOf(wert) === -1) return;
    tempo = wert;
    tempoSpeichern(wert);
    // Laufenden Satz mit dem neuen Tempo neu beginnen
    if (sitzung && sitzung.steuerung.zustand === 'spielt') {
      generation++;
      clearTimeout(wachhund);
      abbrechen();
      var erwartet = generation;
      setTimeout(function () {
        if (erwartet === generation && sitzung && sitzung.steuerung.zustand === 'spielt') sprechen();
      }, 80);
    }
  });

  document.addEventListener('keydown', function (event) {
    // Maus markiert, Tastatur bedient: Ein Klick in den Text fokussiert #MainContent (tabindex=-1, A-28), Tab
    // spraenge dann zum ersten Ziel in main. Steht der schwebende Knopf und liegt der Fokus auf keinem
    // Bedienelement, fuehrt Tab zuerst zu ihm. Reagiert nur auf ausdrueckliches Tab, stiehlt keinen Fokus.
    if (event.key === 'Tab' && !event.shiftKey && !event.altKey && !event.ctrlKey && !event.metaKey) {
      var aktiv = document.activeElement;
      if (
        schwebend &&
        schwebend.leiste.isConnected &&
        !schwebend.leiste.hidden &&
        (!aktiv || aktiv === document.body || aktiv === document.documentElement || aktiv === main)
      ) {
        event.preventDefault();
        schwebend.start.focus({ preventScroll: true });
      }
      return;
    }
    if (event.key !== 'Escape' && event.key !== 'Esc') {
      nutzerScrollt(event);
      return;
    }
    var leiste = event.target instanceof Element ? event.target.closest('[data-sm-vorlesen-leiste]') : null;
    var s = leiste && leiste.smVorlesen;
    if (s) {
      // Escape in einer Leiste beendet das Vorlesen; der Fokus bleibt auf "Vorlesen"
      if (sitzung && sitzung.steuerung === s) beenden(true);
      if (s.art === 'auswahl') auswahlSchliessen(true);
      return;
    }
    // Schwebender Knopf: Escape schliesst ihn, ohne den Fokus zu bewegen
    if (schwebend && !schwebend.leiste.hidden) {
      if (sitzung && sitzung.steuerung === schwebend) beenden(true);
      auswahlSchliessen(true);
    }
  });

  /* ---------- Markierten Text vorlesen ---------- */

  var schwebend = null; // Steuerung des schwebenden Knopfs
  var auswahlTimer = 0;
  var herkunft = null; // Element, von dem der Fokus in den schwebenden Knopf kam
  var unterdrueckt = null; // per Escape geschlossene Markierung nicht sofort wieder anbieten
  var grobZeiger = window.matchMedia ? window.matchMedia('(pointer: coarse)') : null;

  function schwebendBauen() {
    if (schwebend) return schwebend;
    schwebend = steuerungBauen('auswahl', '');
    var leiste = schwebend.leiste;
    leiste.hidden = true;
    // Maus und Touch: Knoepfe nehmen keinen Fokus und heben die Markierung nicht auf
    leiste.addEventListener('mousedown', function (event) {
      if (event.target instanceof Element && event.target.closest('button')) event.preventDefault();
    });
    leiste.addEventListener('focusin', function (event) {
      if (event.relatedTarget instanceof HTMLElement && !leiste.contains(event.relatedTarget)) herkunft = event.relatedTarget;
    });
    leiste.addEventListener('focusout', function (event) {
      if (!event.relatedTarget || !leiste.contains(event.relatedTarget)) setTimeout(auswahlPruefen, 0);
    });
    return schwebend;
  }

  function gueltigeAuswahl() {
    var auswahl = window.getSelection ? window.getSelection() : null;
    if (!auswahl || auswahl.isCollapsed || !auswahl.rangeCount) return null;
    // nicht in Formularfeldern
    var aktiv = document.activeElement;
    if (aktiv && (aktiv.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(aktiv.nodeName))) return null;

    var bereich = auswahl.getRangeAt(0);
    var anfang = elementVon(bereich.startContainer);
    var ende = elementVon(bereich.endContainer);
    if (!anfang || !ende || !main.contains(anfang) || !main.contains(ende)) return null;
    var ausnahme = 'input, textarea, select, [contenteditable]:not([contenteditable="false"]), [data-sm-vorlesen-leiste]';
    if (anfang.closest(ausnahme) || ende.closest(ausnahme)) return null;

    var text = auswahl.toString().replace(/\s+/g, ' ').trim();
    if (text.split(' ').length < 2) return null; // mindestens zwei Woerter
    return { bereich: bereich.cloneRange(), text: text };
  }

  /* Der Knopf kommt als letztes Kind in den innersten Textblock mit dem Ende der Markierung, damit Tab ihn
   * direkt nach dem markierten Text erreicht. Als Kind (nicht als Geschwister) bleiben :last-child- und
   * "+"-Regeln der Umgebung unberuehrt (position: fixed, also ohne Einfluss auf das Layout).
   * Nie in Links, Knoepfe, summary oder label; dann ans Ende von body (Tab fuehrt per keydown hin). */
  var ANKER_BLOCK = 'p, li, h1, h2, h3, h4, h5, h6, dt, dd, td, th, blockquote, figcaption, caption, pre, address, .sm-faq__a';
  var NICHT_IN = 'a, button, summary, label, select, textarea, input, [contenteditable]:not([contenteditable="false"])';

  function einfuegeAnker(bereich) {
    var knoten = bereich.endContainer;
    if (bereich.endOffset === 0) {
      // Ende am Anfang eines Knotens (z. B. Dreifachklick): eigentlich endet die Markierung im Knoten davor
      var k = knoten;
      while (k && k !== main && !k.previousSibling) k = k.parentNode;
      if (k && k !== main && k.previousSibling) {
        k = k.previousSibling;
        while (k.lastChild) k = k.lastChild;
        knoten = k;
      }
    } else if (knoten.nodeType === 1 && knoten.childNodes[bereich.endOffset - 1]) {
      knoten = knoten.childNodes[bereich.endOffset - 1];
    }
    var el = elementVon(knoten);
    var block = el && el.closest(ANKER_BLOCK);
    if (!block || !main.contains(block) || block.closest(NICHT_IN)) return null;
    return block;
  }

  function auswahlPruefen() {
    auswahlTimer = 0;
    if (!stimme) {
      auswahlSchliessen(false);
      return;
    }
    // Waehrend die Markierung vorgelesen wird, bleibt der Knopf stehen
    if (schwebend && sitzung && sitzung.steuerung === schwebend) return;

    var info = gueltigeAuswahl();
    if (info && !gleicheAuswahl(info.bereich, unterdrueckt)) {
      unterdrueckt = null;
      auswahlZeigen(info);
      return;
    }
    if (!info) unterdrueckt = null;
    if (schwebend && !schwebend.leiste.hidden && !schwebend.leiste.contains(document.activeElement)) auswahlSchliessen(false);
  }

  function gleicheAuswahl(a, b) {
    return (
      !!a &&
      !!b &&
      a.startContainer === b.startContainer &&
      a.startOffset === b.startOffset &&
      a.endContainer === b.endContainer &&
      a.endOffset === b.endOffset
    );
  }

  function auswahlZeigen(info) {
    var s = schwebendBauen();
    s.text = info.text;
    s.bereichAuswahl = info.bereich;
    if (!s.leiste.contains(document.activeElement)) {
      var ziel = einfuegeAnker(info.bereich) || document.body;
      if (s.leiste.parentNode !== ziel || ziel.lastChild !== s.leiste) ziel.appendChild(s.leiste);
    }
    s.leiste.hidden = false;
    auswahlPositionieren();
  }

  // perEscape: dieselbe Markierung danach nicht sofort wieder anbieten
  function auswahlSchliessen(perEscape) {
    var s = schwebend;
    if (!s || !s.leiste.isConnected) return;
    var hatteFokus = s.leiste.contains(document.activeElement);
    if (perEscape && s.bereichAuswahl) unterdrueckt = s.bereichAuswahl;
    s.leiste.hidden = true;
    s.bereichAuswahl = null;
    // Fokus dorthin zurueck, woher er kam. Kam er von main oder body (Klick in den Text), nicht auf main
    // setzen (A-28: dort unsichtbar, Tab finge oben an): Der Knopf verschwindet, der Browser behaelt den
    // Startpunkt fuer Tab an seiner Stelle im Text.
    var ziel = herkunft && herkunft.isConnected && herkunft !== main && herkunft !== document.body ? herkunft : null;
    if (hatteFokus && ziel) ziel.focus({ preventScroll: true });
    herkunft = null;
    // Aus dem DOM nehmen, damit er keine Selektoren der Umgebung beeinflusst
    s.leiste.parentNode.removeChild(s.leiste);
  }

  // Unter der Markierung, im sichtbaren Bereich; Touch mit mehr Abstand wegen der Markierungsgriffe
  function auswahlPositionieren() {
    var s = schwebend;
    if (!s || s.leiste.hidden || !s.bereichAuswahl) return;
    var rechtecke = s.bereichAuswahl.getClientRects();
    var letztes = rechtecke.length ? rechtecke[rechtecke.length - 1] : s.bereichAuswahl.getBoundingClientRect();
    var erstes = rechtecke.length ? rechtecke[0] : letztes;
    if (!letztes.width && !letztes.height) return;

    var leiste = s.leiste;
    var breite = leiste.offsetWidth;
    var hoehe = leiste.offsetHeight;
    var vw = document.documentElement.clientWidth || window.innerWidth;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var abstand = grobZeiger && grobZeiger.matches ? 28 : 10;

    var x = Math.min(Math.max(8, letztes.left), vw - breite - 8);
    var y = letztes.bottom + abstand;
    if (y + hoehe > vh - 8) y = erstes.top - hoehe - abstand;
    y = Math.min(Math.max(8, y), vh - hoehe - 8);
    x = Math.max(8, x);

    leiste.style.left = x + 'px';
    leiste.style.top = y + 'px';
    // Korrektur, falls ein Vorfahr mit transform den Bezugsrahmen fuer position: fixed verschiebt
    var ist = leiste.getBoundingClientRect();
    if (Math.abs(ist.left - x) > 0.5 || Math.abs(ist.top - y) > 0.5) {
      leiste.style.left = 2 * x - ist.left + 'px';
      leiste.style.top = 2 * y - ist.top + 'px';
    }
  }

  var positionGeplant = false;

  function positionPlanen() {
    if (positionGeplant || !schwebend || schwebend.leiste.hidden) return;
    positionGeplant = true;
    requestAnimationFrame(function () {
      positionGeplant = false;
      auswahlPositionieren();
    });
  }

  document.addEventListener('selectionchange', function () {
    // Aufgehobene Markierung gibt die per Escape geschlossene sofort wieder frei (ohne Debounce,
    // sonst sieht auswahlPruefen nach erneutem Markieren nur den unterdrueckten Endzustand)
    var auswahl = window.getSelection ? window.getSelection() : null;
    if (!auswahl || auswahl.isCollapsed) unterdrueckt = null;
    clearTimeout(auswahlTimer);
    auswahlTimer = setTimeout(auswahlPruefen, 250);
  });
  // Am Desktop scrollt .page-wrapper statt des Fensters: scroll blubbert nicht, deshalb Capture
  document.addEventListener('scroll', positionPlanen, true);
  window.addEventListener('resize', positionPlanen);

  /* ---------- Seite verlassen, Hintergrund ---------- */

  window.addEventListener('pagehide', function () {
    beenden(false);
    auswahlSchliessen(false);
  });
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) abgleichPlanen();
  });
  // Mobile Browser brechen die Ausgabe im Hintergrund still ab: dann als Pause am aktuellen Satz behandeln
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState !== 'visible' || !sitzung || sitzung.steuerung.zustand !== 'spielt') return;
    var erwartet = generation;
    setTimeout(function () {
      if (erwartet !== generation || !sitzung || sitzung.steuerung.zustand !== 'spielt') return;
      if (!synth.speaking && !synth.pending) pausieren();
    }, 600);
  });
})();
